import { useMutation } from "urql";

import { UploadFilesMutationDocument } from "../../../graphql/generated.ts";

export function useUploadFiles() {
  return useMutation(UploadFilesMutationDocument);
}
